/// <amd-module name="TFS/Admin/Groups/Pivots/GroupMembers/Redux/GroupMembersPivotSelectors" />
import { IGroupMembersPivotAwareState, SelectableGraphMember, ISearchResultCache, QueryMembers } from "TFS/Admin/Groups/Common/Contracts";
import { GraphMembership } from "VSS/Platform/Contracts/Graph";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { IIdentity } from "VSSUI/IdentityPicker";
import { ObservableArray } from "VSS/Core/Observable";
import { IOperationStatus } from "TFS/Admin/Common/Constants/Constants";
import { SearchStatus, MemberOperation } from "TFS/Admin/Groups/Common/Constants";

export function getSearchKeyword(state: IGroupMembersPivotAwareState): string | undefined {
    return state && state.groupMembersState && state.groupMembersState.searchResult && state.groupMembersState.searchResult.keyword;
}

export function getLoading(state: IGroupMembersPivotAwareState): boolean {
    if (!state || !state.groupMembersState) {
        return true;
    }
    return state.groupMembersState.loading;
}

export function getMembers(state: IGroupMembersPivotAwareState): GraphMembership[] {
    if (!state || !state.groupMembersState || !state.groupMembersState.identities) {
        return [];
    }

    return state.groupMembersState.identities;
}

export function getUsers(state: IGroupMembersPivotAwareState): ObservableArray<SelectableGraphMember> {
    if (!state || !state.groupMembersState || !state.groupMembersState.users) {
        return new ObservableArray([]);
    }

    return state.groupMembersState.users;
}

export function getSearchResult(state: IGroupMembersPivotAwareState): ISearchResultCache {
    if (!state || !state.groupMembersState) {
        return {
            keyword: "",
            resultItems: [],
            status: SearchStatus.None,
            hasMore: false
        };
    }
    return state.groupMembersState.searchResult;
}

export function getShowDeleteMemberDialog(state: IGroupMembersPivotAwareState): boolean {
    if (!state || !state.groupMembersState || !state.groupMembersState.users) {
        return false;
    }

    return state.groupMembersState.showDeleteDialog;
}

export function getSelectedItem(state: IGroupMembersPivotAwareState): SelectableGraphMember | undefined {
    if (!state || !state.groupMembersState || !state.groupMembersState.users) {
        return undefined;
    }

    return state.groupMembersState.selectedItem;
}

export function getShowMessageCard(state: IGroupMembersPivotAwareState): boolean {
    if (!state || !state.groupMembersState || !state.groupMembersState.users) {
        return false;
    }

    return state.groupMembersState.showMessageCard;
}

export function getMessageCardText(state: IGroupMembersPivotAwareState): string {
    if (!state || !state.groupMembersState || !state.groupMembersState.users) {
        return "";
    }

    return state.groupMembersState.messageCardText;
}

export function getMessageCardSeverity(state: IGroupMembersPivotAwareState): MessageCardSeverity {
    if (!state || !state.groupMembersState || !state.groupMembersState.users) {
        return MessageCardSeverity.Info;
    }

    return state.groupMembersState.messageCardSeverity;
}

export function getShowAddMemberPanel(state: IGroupMembersPivotAwareState): boolean {
    if (!state || !state.groupMembersState) {
        return false;
    }

    return state.groupMembersState.showAddMemberPanel;
}

export function getInvalidMembers(state: IGroupMembersPivotAwareState): IIdentity[] {
    if (!state || !state.groupMembersState || !state.groupMembersState.invalidMembers) {
        return [];
    }

    return state.groupMembersState.invalidMembers;
}

export function getValidMembers(state: IGroupMembersPivotAwareState): IIdentity[] {
    if (!state || !state.groupMembersState || !state.groupMembersState.validMembers) {
        return [];
    }

    return state.groupMembersState.validMembers;
}

export function isAadOrg(state: IGroupMembersPivotAwareState): boolean {
    if (!state || !state.groupMembersState) {
        return false;
    }
    return state.groupMembersState.isAadOrg;
}

export function getMultiOperationStatuses(state: IGroupMembersPivotAwareState): IOperationStatus[] {
    if (!state || !state.groupMembersState || !state.groupMembersState.multiOperationStatuses) {
        return [];
    }
    return state.groupMembersState.multiOperationStatuses;
}

export function getLastOperation(state: IGroupMembersPivotAwareState): MemberOperation {
    if (!state || !state.groupMembersState || !state.groupMembersState.lastOperation) {
        return MemberOperation.Fetch;
    }
    return state.groupMembersState.lastOperation;
}

export function getQueryMembers(state: IGroupMembersPivotAwareState): QueryMembers {
    if (!state || !state.groupMembersState || !state.groupMembersState.queryMembers) {
        return {};
    }
    return state.groupMembersState.queryMembers;
}

export function getSupportServicePrincipals(state: IGroupMembersPivotAwareState): boolean {
    if (!state || !state.groupMembersState) {
        return false;
    }

    return state.groupMembersState.supportServicePrincipals;
}
